import { render, staticRenderFns } from "./unSubscription.vue?vue&type=template&id=97760746&scoped=true"
import script from "./unSubscription.vue?vue&type=script&lang=js"
export * from "./unSubscription.vue?vue&type=script&lang=js"
import style0 from "./unSubscription.vue?vue&type=style&index=0&id=97760746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97760746",
  null
  
)

export default component.exports